import { render, staticRenderFns } from "./OperatingUnit.vue?vue&type=template&id=61923486"
import script from "./OperatingUnit.vue?vue&type=script&lang=js"
export * from "./OperatingUnit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports